module.exports = __webpack_public_path__ + "static/media/证10拷贝@3x.8d0926db.png";